// src/components/LoadingAnimation.js

import React from "react";
import Lottie from "lottie-react";
// Ficheiro da animação que vamos guardar localmente
import loadingAnimationData from "../animations/loading.json";

const LoadingAnimation = ({ size = 100 }) => {
  const style = {
    height: size,
    width: size,
    margin: "auto", // Centraliza a animação
  };

  return (
    <Lottie animationData={loadingAnimationData} style={style} loop={true} />
  );
};

export default LoadingAnimation;
